import React from "react";
import { hundredDays } from "../data";

export default function Developer() {
  return (
    <section>
      <div className="container mx-auto px-10 py-10 items-center">
        <p className="mb-5">"My 100 days of code journey"</p>
        {/* card  */}
        {hundredDays.map((hundredDays) => (
          <div className="w-full md:h-48 lg:h-64 md:flex lg:flex mb-4">
            <div className="">
              <img
                src={hundredDays.src}
                className="bg-cover  md:w-80 lg:w-96 h-full object-cover"
                alt={hundredDays.alt}
              />
            </div>
            <div className=" bg-white w-full  p-4 flex flex-col justify-between leading-normal">
              <div className="mb-2">
                <div className="text-gray-900 font-bold text-xl mb-2">
                  <p>
                    Day  {hundredDays.day} of #100daysofcode
                  </p>
                </div>
                <h2 className="text-gray-700 font-bold text-xl ">
                  Topic/Project: {hundredDays.topic}
                </h2>
                <p className="text-gray-700 text-base">
                  Description: {hundredDays.desc}
                </p>
                <i className="text-gray-700 text-base">
                  <a href={hundredDays.projectlink} target="_blank">
                    Link to Project |{" "}
                  </a>
                </i>
                <i className="text-gray-700 text-base">
                  <a href={hundredDays.codelink} target="_blank">
                    Source Code
                  </a>
                </i>
                <i className="text-gray-600"> | {hundredDays.date}</i>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
